export default __webpack_public_path__ + "static/media/biofit-builder-series-Z.d7f47e1e.png";